// src/components/pages/templates/TemplateNavigationPage.tsx

import React, { useState } from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import TemplateManagerPage from "./TemplateManagerPage"; // Fixed import path
import TemplateEditorPage from "./TemplateEditorPage";

type TabType = "manager" | "editor";

const TemplateNavigationPage = () => {
  const [activeTab, setActiveTab] = useState<TabType>("editor");

  return (
    <View style={styles.container}>
      {/* Tab Navigation */}
      <View style={styles.tabContainer}>
        <TouchableOpacity
          style={[styles.tab, activeTab === "editor" && styles.activeTab]}
          onPress={() => setActiveTab("editor")}
        >
          <Text
            style={[
              styles.tabText,
              activeTab === "editor" && styles.activeTabText,
            ]}
          >
            ✏️ Template Editor
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={[styles.tab, activeTab === "manager" && styles.activeTab]}
          onPress={() => setActiveTab("manager")}
        >
          <Text
            style={[
              styles.tabText,
              activeTab === "manager" && styles.activeTabText,
            ]}
          >
            📝 Raw Editor
          </Text>
        </TouchableOpacity>
      </View>

      {/* Tab Content */}
      <View style={styles.content}>
        {activeTab === "editor" ? (
          <TemplateEditorPage />
        ) : (
          <TemplateManagerPage /> // Now correctly shows TemplateManagerPage
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#f8f9fa",
  },
  tabContainer: {
    flexDirection: "row",
    backgroundColor: "white",
    borderBottomWidth: 1,
    borderBottomColor: "#dee2e6",
  },
  tab: {
    flex: 1,
    paddingVertical: 16,
    paddingHorizontal: 20,
    backgroundColor: "#f8f9fa",
    borderBottomWidth: 3,
    borderBottomColor: "transparent",
  },
  activeTab: {
    backgroundColor: "white",
    borderBottomColor: "#007bff",
  },
  tabText: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: "600",
    color: "#6c757d",
  },
  activeTabText: {
    color: "#007bff",
  },
  content: {
    flex: 1,
  },
});

export default TemplateNavigationPage;
